import { z } from "zod";

export const PrivacyPolicyResponseSchema = z.object({
	id: z.number(),
	content: z.string(),
	createdAt: z.string(),
});

export type PrivacyPolicyResponse = z.infer<typeof PrivacyPolicyResponseSchema>;
